export default "__VITE_ASSET__L$0s_bA0__"